import { render, staticRenderFns } from "./MMessageDialog.vue?vue&type=template&id=67771cb5&scoped=true&"
import script from "./MMessageDialog.vue?vue&type=script&lang=js&"
export * from "./MMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./MMessageDialog.vue?vue&type=style&index=0&id=67771cb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67771cb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog,VSpacer})
